export default function({ route, store, redirect }) {
  const metaList = route.meta?.filter(item => Boolean(item.require))
  if (!metaList || !metaList.length) return
  const require = metaList[0].require
  const requiredStage = require.stage ?? []
  const currentStage = store.state.foodSolution.stage
  if (!requiredStage.includes(currentStage))
    return redirect(require.notSatisfyRedirectTo ?? '/food-solution')
}
